import React from 'react';
import { Modal } from 'antd';
import { FillButton } from 'components/elements';

// import { createStyles, useTheme } from 'antd-style';
// const useStyle = createStyles(({ token }) => ({
//   'my-modal-body': {
//     background: token['blue-1'],
//     padding: token.paddingSM,
//   },
//   'my-modal-mask': {
//     boxShadow: `inset 0 0 15px #fff`,
//   },
//   'my-modal-header': {
//     borderBottom: `1px dotted ${token.colorPrimary}`,
//   },
//   'my-modal-footer': {
//     color: token.colorPrimary,
//   },
//   'my-modal-content': {
//     border: '1px solid #333',
//   },
// }));

export const SimpleModal = ({ open, title = '', width, height, footer = false, closable = true, onClose, children, zIndex=1000 }) => {
  const onHandleClose = () => {
    if (onClose) onClose();
  };
  // const { styles } = useStyle();

  // const classNames = {
  //   body: styles['my-modal-body'],
  //   mask: styles['my-modal-mask'],
  //   header: styles['my-modal-header'],
  //   footer: styles['my-modal-footer'],
  //   content: styles['my-modal-content'],
  // };
  const modalStyles = {
    header: {
      borderLeft: `5px solid red`,
      borderRadius: 0,
      paddingInlineStart: 5
    },
    body: {
      boxShadow: 'inset 0 0 5px #999',
      borderRadius: 5
    },
    mask: {
      backdropFilter: 'blur(10px)'
    },
    footer: {
      borderTop: '1px solid #333'
    },
    content: {
      boxShadow: '0 0 30px #999'
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      width={width}
      closable={closable}
      onCancel={onHandleClose}
      zIndex={zIndex}
      style={{ top: `calc( (100vh - calc(${height} + 60px + 66px)) * 0.5 )` }}
      styles={{
        header: {
          paddingInlineStart: 22,
          display: 'flex',
          alignItems: 'center',
          height: '60px',
          borderBottom: '1px solid var(--color-gray08)'
        },
        title: {},
        content: {
          padding: '0px 0px 22px 0px'
          // height
        },
        body: {
          padding: '22px',
          overflowY: 'auto',
          height
        }
      }}
      footer={[<div style={{ display: 'flex', justifyContent: 'center', gap: '5px' }}>{footer || <FillButton key={'close'} label={'닫기'} color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} onClick={onHandleClose} />}</div>]}
    >
      {children}
    </Modal>
  );
};
